import { Enum } from './Enum';

export class ReferralMappingRosterType extends Enum {
  translationKey = 'referralMappingRosterType';

  static asArray: ReferralMappingRosterType[] = [];

  static byKey: { [name: string]: ReferralMappingRosterType } = {};

  static readonly MEMBER = new ReferralMappingRosterType('MEMBER');

  static readonly CANDIDATE = new ReferralMappingRosterType('CANDIDATE');

  constructor(public readonly value: string) {
    super();
    ReferralMappingRosterType.asArray.push(this);
    ReferralMappingRosterType.byKey[value] = this;
  }
}

export default ReferralMappingRosterType;
